module["exports"] = [
  "Pty Ltd",
  "Ltd",
  "CC"
];
